var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar__used",attrs:{"data-cy":_vm.dataCy}},[_c('span',{style:(_vm.progressStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }